export default __webpack_public_path__ + "static/graphik-regular-web-e4ad9842211b1a2c38e3939bc1ee11ea.woff2";